// extracted by mini-css-extract-plugin
export default {"wrapper":"_1_posters_wrapper__VQLxQ","poster":"_1_posters_poster__GqyRa"};